import React, { useState, lazy } from 'react';
import { trackEvent } from '../utils/pixel';
/* ─── BUNDLE UPSELL POPUP ─── */
function BundleUpsellPopup({
  onClose,
  formatPrice
}: {
  onClose: () => void;
  formatPrice: (n: number) => string;
}) {
  return <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4" data-id="element-127">
      <style data-id="element-128">{`
        @keyframes flash-badge {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.7; transform: scale(1.05); }
        }
        @keyframes pulse-glow {
          0%, 100% { box-shadow: 0 0 20px rgba(230,126,34,0.4); }
          50% { box-shadow: 0 0 35px rgba(230,126,34,0.7), 0 0 60px rgba(230,126,34,0.3); }
        }
        @keyframes bundle-pop-in {
          from { opacity: 0; transform: scale(0.92) translateY(16px); }
          to { opacity: 1; transform: scale(1) translateY(0); }
        }
        .flash-badge { animation: flash-badge 1.2s ease-in-out infinite; }
        .pulse-glow { animation: pulse-glow 2s ease-in-out infinite; }
        .bundle-pop-in { animation: bundle-pop-in 0.35s ease-out forwards; }
      `}</style>
      <div className="bg-white w-full max-w-[370px] rounded-[20px] shadow-2xl relative overflow-hidden bundle-pop-in" style={{
      maxHeight: '560px',
      fontFamily: "'Nunito', sans-serif"
    }} data-id="element-129">
        {/* Close button */}
        <button onClick={onClose} className="absolute top-3 right-3 z-10 text-white/70 hover:text-white transition-colors" data-id="element-130">
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-131">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-132" />
          </svg>
        </button>

        {/* Body */}
      </div>
    </div>;
}
/* ─── FOR WHOM ─── */
export function ForWhomSection() {
  return null;
}
/* ─── CHECKOUT FLOW (Order Bumps) ─── */
export function OrderBumpsSection() {
  const [bump1, setBump1] = useState(false);
  const [bump2, setBump2] = useState(false);
  const [showUpsell, setShowUpsell] = useState(false);
  const basePrice = 14999;
  const bump1Price = 3990;
  const bump2Price = 2990;
  const total = basePrice + (bump1 ? bump1Price : 0) + (bump2 ? bump2Price : 0);
  const productCount = 1 + (bump1 ? 1 : 0) + (bump2 ? 1 : 0);
  const formatPrice = (price: number) => {
    return '$' + price.toLocaleString('es-AR').replace(',', '.');
  };
  // Build product name list
  const productNames = ['Kit Método 3C'];
  if (bump1) productNames.push('Jugos Camuflados');
  if (bump2) productNames.push('Tabla Mágica');
  // Dynamic Shopify cart URL based on selection
  const getCheckoutUrl = () => {
    if (bump1 && bump2) return 'https://vitaliaguides.com/cart/46709797519537:1';
    if (bump1) return 'https://vitaliaguides.com/cart/46709792800945:1';
    if (bump2) return 'https://vitaliaguides.com/cart/46709795684529:1';
    return 'https://vitaliaguides.com/cart/46709792178353:1';
  };
  const handleCheckoutClick = (e: React.MouseEvent) => {
    // If no bumps selected, intercept and show upsell popup
    if (!bump1 && !bump2) {
      e.preventDefault();
      setShowUpsell(true);
      return;
    }
    // Otherwise, fire pixel and let the link navigate normally
    trackEvent('AddToCart', {
      content_name: productNames.join(' + '),
      content_type: 'product',
      value: total / 100,
      currency: 'ARS',
      num_items: productCount
    });
  };
  return;
}
/* ─── GUARANTEE ─── */
export function GuaranteeSection() {
  return;
}
/* ─── URGENCY ─── */
export function UrgencySection() {
  return null;
}
/* ─── FINAL CTA ─── */
export function FinalCTASection() {
  return <section id="cta" style={{
    background: 'linear-gradient(135deg, #2C3E50, #34495e)'
  }} className="py-10 px-5 sm:py-12 sm:px-6 text-center" data-id="element-133">
      <style data-id="element-134">{`
        @keyframes pulse-orange-glow {
          0%, 100% { box-shadow: 0 0 20px rgba(255,107,0,0.4); }
          50% { box-shadow: 0 0 40px rgba(255,107,0,0.7), 0 0 80px rgba(255,107,0,0.25); }
        }
        .pulse-orange-cta { animation: pulse-orange-glow 2.5s ease-in-out infinite; }
      `}</style>
      <div className="max-w-[500px] mx-auto" data-id="element-135">
        <h2 className="text-white text-[26px] sm:text-[30px] font-black mb-4 leading-tight" data-id="element-136">
          La próxima comida puede ser diferente.
        </h2>
        <p className="text-white/80 text-[15px] leading-relaxed mb-8" data-id="element-137">
          No porque tu hijo madure. No porque de repente le guste. Sino porque
          vos vas a saber exactamente cómo presentarla.
        </p>
        <div className="mb-8" data-id="element-138">
          <span className="text-white/40 text-sm line-through block mb-1" data-id="element-139">
            $35.799
          </span>
          <span className="text-[#F5C842] text-[42px] font-black block leading-none" data-id="element-140">
            $14.999
          </span>
          <span className="text-[#27AE60] text-[18px] sm:text-[20px] font-black block mt-2" data-id="element-141">
            Ahorrás $20.800
          </span>
        </div>
        <a href="#order" className="pulse-orange-cta text-white text-[16px] font-black py-5 px-8 rounded-2xl block w-full transition-all duration-200" style={{
        background: '#FF6B00'
      }} data-id="element-142">
          SÍ, QUIERO EL MÉTODO 3C — ACCESO INMEDIATO
        </a>

        {/* Payment trust + icons */}
        <img src="https://cdn.magicpatterns.com/uploads/w5y4NrCNFhtKGREXWxX61b/metodos_de_pago.png" alt="Métodos de pago: Mercado Pago, Visa, MasterCard" className="mx-auto w-full max-w-[280px] object-contain opacity-70 mt-6 mb-2" loading="lazy" data-id="element-143" />
        <p className="text-white/70 text-[12px] mb-4" data-id="element-144">
          Acceso seguro y encriptado. Recibís el material en tu email al
          instante.
        </p>
      </div>
    </section>;
}
/* ─── WHATSAPP TESTIMONIALS ─── */
export function WhatsAppTestimonialsSection() {
  const testimonials = [{
    name: 'Carla',
    img: 'https://cdn.magicpatterns.com/uploads/qBeAp9Q3ep6rcdWe4PDvhx/CARLA.png'
  }, {
    name: 'Florencia',
    img: 'https://cdn.magicpatterns.com/uploads/myhcDtZLL5dvmdkTEDDccQ/FLORENCIA.png'
  }, {
    name: 'Valentina',
    img: 'https://cdn.magicpatterns.com/uploads/1J1DozQ5HATUFBJWhFPbug/VALENTINA.png'
  }];
  return <section className="bg-[#FDF9F3] py-8 px-5 sm:py-10 sm:px-6" data-id="element-145">
      <div className="max-w-[720px] mx-auto" data-id="element-146">
        <p className="text-[#5E8D5A] text-[11px] sm:text-[12px] font-black tracking-[2px] text-center uppercase mb-1.5" data-id="element-147">
          💬 TESTIMONIOS REALES
        </p>
        <h2 className="text-[#2C3E50] text-[22px] sm:text-[26px] font-black text-center mb-6 leading-tight tracking-tight" data-id="element-148">
          Lo que dicen quienes ya usaron el método
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-149">
          {testimonials.map((t, i) => <div key={i} className="rounded-2xl overflow-hidden shadow-[0_4px_24px_rgba(0,0,0,0.10)] bg-white" data-id="element-150">
              <img src={t.img} alt={`Testimonio de ${t.name} por WhatsApp`} className="w-full h-auto object-contain" loading="lazy" data-id="element-151" />
            </div>)}
        </div>
      </div>
    </section>;
}
/* ─── FAQ ─── */
const faqs = [{
  q: '¿Para qué edades sirve?',
  a: 'Diseñado específicamente para nenes de 3 a 12 años que presentan selectividad alimentaria o rechazo a texturas nuevas.'
}, {
  q: '¿Es un curso o un libro?',
  a: 'Es un Kit Digital Completo. Recibís la Guía Maestra + 5 Bonos descargables para ver en tu celu, tablet o compu para siempre.'
}, {
  q: 'No tengo tiempo de cocinar raro, ¿me sirve?',
  a: '¡Sí! El Método 3C se basa en comida real y técnicas de presentación que te ahorran tiempo, no te lo quitan.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Acceso inmediato. Apenas se acredita el pago, recibís un mail con el link de descarga para empezar hoy mismo.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-[#F4F4F4] py-8 px-5 sm:py-10 sm:px-6" data-id="element-152">
      <div className="max-w-[500px] mx-auto" data-id="element-153">
        <h2 className="text-[#2C3E50] text-[24px] sm:text-[28px] font-black text-center mb-6 leading-tight" data-id="element-154">
          Preguntas Frecuentes
        </h2>
        <div className="flex flex-col gap-3" data-id="element-155">
          {faqs.map((faq, i) => <div key={i} className="bg-white rounded-xl p-4 sm:p-5 cursor-pointer border border-gray-100 shadow-sm" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-156">
              <div className="flex justify-between items-center gap-4" data-id="element-157">
                <span className="text-[#2C3E50] text-[15px] font-bold leading-snug" data-id="element-158">
                  {faq.q}
                </span>
                <span className={`text-[#5E8D5A] text-xl flex-shrink-0 transition-transform duration-200 ${openIndex === i ? 'rotate-45' : ''}`} data-id="element-159">
                  +
                </span>
              </div>
              {openIndex === i && <p className="text-[#6B7280] text-[14px] leading-relaxed mt-3 pt-3 border-t border-gray-50" data-id="element-160">
                  {faq.a}
                </p>}
            </div>)}
        </div>
      </div>
    </section>;
}
/* ─── FOOTER ─── */
export function FooterSection() {
  return <footer className="bg-white py-10 px-5 sm:px-6 text-center border-t border-gray-100" data-id="element-161">
      <div className="max-w-[500px] mx-auto" data-id="element-162">
        <div className="text-[#2C3E50] text-lg font-black mb-4 tracking-tight" data-id="element-163">
          VITALIA guides 🌿
        </div>
        <div className="flex justify-center items-center flex-wrap gap-4 mb-6" data-id="element-164">
          <span className="text-gray-500 text-[11px] font-bold uppercase tracking-wider" data-id="element-165">
            🛡️ Garantía 7 días
          </span>
          <span className="text-gray-500 text-[11px] font-bold uppercase tracking-wider" data-id="element-166">
            💳 Pago seguro
          </span>
        </div>
        <div className="text-gray-400 text-[12px] mb-3 flex justify-center gap-3" data-id="element-167">
          <a href="#" className="hover:text-gray-600 transition-colors" data-id="element-168">
            Privacidad
          </a>
          <span data-id="element-169">·</span>
          <a href="#" className="hover:text-gray-600 transition-colors" data-id="element-170">
            Términos
          </a>
        </div>
        <div className="text-gray-300 text-[11px]" data-id="element-171">© 2026 Vitalia Guides</div>
      </div>
    </footer>;
}